module.exports = __webpack_public_path__ + "static/media/visitor4.106c894f.jpeg";